import errorReporter from '@app/errorReporter';
import { formatPhoneNumber } from 'utils';

angular.module('bb.listing_contacts').component('listingContacts', {
  controller: ListingContactsController,
  controllerAs: 'vm',
  template: require('./listing_contacts_new.html'),
  bindings: {
    listingId: '=',
    appointmentConfig: '=',
  },
});

ListingContactsController.$inject = [
  '$rootScope',
  'ListingContactsService',
  'userService',
  '$q',
];

function ListingContactsController(
  $rootScope,
  ListingContactsService,
  userService,
  $q,
) {
  const vm = this;

  vm.$onInit = function () {
    const agentIds = vm.appointmentConfig.contacts
      .filter(contact => contact.type === 'Agent')
      .map(contact => contact.contactId);

    $q.all([
      userService.getFullUsers(agentIds),
      ListingContactsService.getListingContacts(vm.listingId),
    ])
      .then(function ([reps, listingContacts]) {
        vm.repsById = [];
        reps.forEach(rep => {
          vm.repsById[rep.id] = rep;
        });
        vm.listingContacts = listingContacts;
      })
      .catch(function (err) {
        errorReporter.error(err);
        // TOAST
      })
      .finally(function () {
        vm.contactsLoaded = true;
      });
  };

  vm.openContactDrawer = $rootScope.openContactDrawer;

  vm.formatPhoneNumber = formatPhoneNumber;

  vm.hasListingContact = contact =>
    Object.keys(vm.listingContacts || {}).includes(
      contact.id || contact.contactId,
    );

  vm.isEmpty = function (obj) {
    if (!obj) return true;

    for (const i in obj) {
      if (obj[i]) return false;
    }
    return true;
  };

  vm.getMultiConfIndex = ({ contactId }) => {
    const multiConfContacts = vm.appointmentConfig.contacts
      .filter(contact => contact.mustConfirm)
      .map(contact => contact.contactId);
    return `(${multiConfContacts.indexOf(contactId) + 1} of ${
      multiConfContacts.length
    })`;
  };
}
